import { cx } from '../../../utils/cx';
import type { TicketStatus } from '../../../types/support';
import styles from './StatusPill.module.scss';
import React from 'react';

const statusLabels: Record<string, string> = {
  new: 'Новое',
  run: 'В работе',
  waiting: 'Ожидает',
  done: 'Завершён',
  closed: 'Закрыт',
  draft: 'Черновик',
  archived: 'В архиве',
};

interface StatusPillProps {
  status: TicketStatus | string;
  children?: string;
  compact?: boolean;
}

export function StatusPill({ status, children, compact }: StatusPillProps) {
  return (
    <span className={cx(styles.pill, styles[status], compact && styles.compact)}>
      {children ?? statusLabels[status] ?? status}
    </span>
  );
}